var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeafy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9724 26.6981C52.9724 41.2513 41.1747 53.049 26.6214 53.049C12.0682 53.049 0.270508 41.2513 0.270508 26.6981C0.270508 12.1449 12.0682 0.347168 26.6214 0.347168C41.1747 0.347168 52.9724 12.1449 52.9724 26.6981Z",
    fill: "#2D63F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1938 12.2051H33.8912C31.7756 12.2051 29.8663 13.0285 28.4214 14.3152C29.7115 15.9621 30.5371 18.0208 30.5371 20.2853C34.3041 19.5133 37.1938 16.2195 37.1938 12.2051ZM25.6349 20.4397V26.204C25.6349 26.6672 25.9961 27.0275 26.4605 27.0275H28.1118C28.5246 27.0275 28.9374 26.6672 28.9374 26.204V20.4397C28.9374 15.9107 25.2221 12.2051 20.6811 12.2051H17.3785C17.3785 16.7856 21.0423 20.4397 25.6349 20.4397ZM41.58 29.1376C40.9608 28.5715 40.0319 28.6229 39.3611 29.1376L34.6137 32.8947C34.0461 33.4093 33.272 33.6152 32.5496 33.6152H26.4605C25.9961 33.6152 25.6349 33.2549 25.6349 32.7917C25.6349 32.38 25.9961 31.9683 26.4605 31.9683H30.4855C31.3111 31.9683 32.0852 31.4536 32.1884 30.6301C32.3432 29.6008 31.5691 28.6744 30.5887 28.6744H22.3323C20.9391 28.6744 19.5458 29.1891 18.4622 30.064L16.0884 31.9683H13.2503C12.7859 31.9683 12.4247 32.38 12.4247 32.7917V37.7325C12.4247 38.1957 12.7859 38.556 13.2503 38.556H31.6207C32.3948 38.556 33.1172 38.3502 33.6848 37.8355L41.5284 31.608C42.3024 30.9904 42.354 29.8067 41.58 29.1376Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafy);
export default __webpack_public_path__ + "static/media/leafy.ebf81bad5a18ac9b8accf3fbd4d876dc.svg";
export { ForwardRef as ReactComponent };